// A PDI sheet's SAMPLE checklists: under each model heading (e.g. "GT7", "45") the sheet keeps a boat titled
// "SAMPLE <model>" (or just "SAMPLE"), with the model's check sections (marked `*` in the Tag column) and
// their items under it. A new boat is put on the sheet by copying its model's SAMPLE: the boat's own row
// (SAP, name, `*`) under the model heading, then the sections and items, names and `*` only, never results.
/** the most rows a boat may be copied with (a SAMPLE is ~130) */
export const PDI_SAMPLE_MAX_ROWS = 600;
const text = (v) => (typeof v === 'string' ? v.trim() : '');
/** a heading or SAMPLE name as people read it: "45.0" → "45", spaces tidied */
export const pdiModelName = (s) => s.trim().replace(/\.0+$/, '').replace(/\s+/g, ' ');
/** models compared loosely: "38 GS" = "38GS", "45" = "45.0" */
export const pdiModelKey = (s) => pdiModelName(s).toUpperCase().replace(/[\s_-]+/g, '');
const isSample = (name) => /^SAMPLE\b/i.test(name);
function childrenOf(rows) {
    const m = new Map();
    for (const r of rows) {
        const k = r.parentId ?? null;
        const list = m.get(k);
        if (list)
            list.push(r);
        else
            m.set(k, [r]);
    }
    return m;
}
/** the SAMPLE checklists on a PDI sheet, in sheet order */
export function pdiSamples(rows, cols) {
    const byId = new Map(rows.map((r) => [r.id, r]));
    const kids = childrenOf(rows);
    const count = (id) => (kids.get(id) ?? []).reduce((n, c) => n + 1 + count(c.id), 0);
    const out = [];
    for (const r of rows) {
        const name = text(r.cells[String(cols.name)]);
        if (!isSample(name))
            continue;
        const parent = r.parentId != null ? byId.get(r.parentId) : undefined;
        const own = pdiModelName(name.replace(/^SAMPLE\b[\s:_-]*/i, ''));
        const model = own || (parent ? pdiModelName(text(parent.cells[String(cols.name)])) : '') || 'Sample';
        out.push({ rowId: r.id, model, parentId: r.parentId ?? null, rows: 1 + count(r.id) });
    }
    return out;
}
/** a SAMPLE's sections and items, as the tree a new boat gets */
export function pdiSampleTree(rows, cols, sampleId) {
    const kids = childrenOf(rows);
    const walk = (id) => (kids.get(id) ?? []).map((r) => ({
        name: text(r.cells[String(cols.name)]),
        section: cols.tag != null && text(r.cells[String(cols.tag)]) === '*',
        children: walk(r.id),
    }));
    return walk(sampleId);
}
//# sourceMappingURL=pdiSample.js.map